module.exports = __webpack_public_path__ + "img/temasek-logo.e3516e74.png";